export const convertSearchEntitySlug = (
  value: string,
  direction: "toSlug" | "toQuery" = "toSlug"
): string =>
  direction === "toSlug"
    ? value.replaceAll(" ", "-")
    : value.replaceAll("-", " ");
